{
 "narcis": {
  "colour:black": 0.1099,
  "colour:blue": 0.1054,
  "colour:brown": 0.0681,
  "colour:gold": 0.0544,
  "colour:green": 0.0791,
  "colour:grey": 0.0925,
  "colour:multicolour": 0.0603,
  "colour:orange": 0.0449,
  "colour:pink": 0.0321,
  "colour:purple": 0.0166,
  "colour:red": 0.101,
  "colour:white": 0.1613,
  "colour:yellow": 0.0157,
  "era:ancient": 0.0129,
  "era:contemporary": 0.6596,
  "era:early-1900s": 0.099,
  "era:early-modern": 0.0399,
  "era:late-1900s": 0.0787,
  "era:medieval": 0.0289,
  "era:nineteenth": 0.0505,
  "era:timeless": 0.0206,
  "region:africa": 0.034,
  "region:east-asia": 0.0699,
  "region:europe": 0.4314,
  "region:latin-america": 0.0432,
  "region:middle-east": 0.058,
  "region:north-america": 0.1951,
  "region:oceania": 0.0186,
  "region:south-asia": 0.0474,
  "region:southeast-asia": 0.0176,
  "role:artist": 0.0232,
  "role:athlete": 0.0387,
  "role:celebrant": 0.0798,
  "role:explorer": 0.085,
  "role:mythic": 0.0188,
  "role:performer": 0.1547,
  "role:professional": 0.3397,
  "role:ruler": 0.0453,
  "role:warrior": 0.0195,
  "use:art": 0.0425,
  "use:dating": 0.0909,
  "use:fashion": 0.1512,
  "use:headshots": 0.1963,
  "use:heritage": 0.1073,
  "use:history": 0.0235,
  "use:icons": 0.0669,
  "use:myth": 0.0019,
  "use:nature": 0.0085,
  "use:nightlife": 0.0146,
  "use:professions": 0.1449,
  "use:red-carpet": 0.011,
  "use:sport": 0.0355,
  "use:travel": 0.0824,
  "use:weddings": 0.0223
 },
 "ovid": {
  "colour:black": 0.2111,
  "colour:blue": 0.0643,
  "colour:brown": 0.0203,
  "colour:gold": 0.0565,
  "colour:green": 0.0531,
  "colour:grey": 0.0409,
  "colour:multicolour": 0.0793,
  "colour:orange": 0.0141,
  "colour:pink": 0.0381,
  "colour:purple": 0.0137,
  "colour:red": 0.1149,
  "colour:white": 0.2142,
  "colour:yellow": 0.0112,
  "garment:bare": 0.0846,
  "garment:casual": 0.1327,
  "garment:costume": 0.1246,
  "garment:evening": 0.1052,
  "garment:fetishwear": 0.0397,
  "garment:lingerie": 0.1693,
  "garment:sheer": 0.1115,
  "garment:sportswear": 0.0259,
  "garment:swimwear": 0.0528,
  "garment:traditional": 0.1405,
  "scenario:art": 0.06,
  "scenario:beach": 0.0912,
  "scenario:boudoir": 0.3148,
  "scenario:cosplay": 0.0006,
  "scenario:everyday": 0.0734,
  "scenario:fantasy": 0.0687,
  "scenario:fetish": 0.0353,
  "scenario:heritage": 0.0337,
  "scenario:history": 0.0197,
  "scenario:luxury": 0.0568,
  "scenario:nightlife": 0.0675,
  "scenario:outdoors": 0.0621,
  "scenario:roles": 0.0996,
  "scenario:sport": 0.0166,
  "setting:city": 0.075,
  "setting:imagined": 0.0209,
  "setting:interior": 0.4988,
  "setting:landmark": 0.0443,
  "setting:nature": 0.104,
  "setting:studio": 0.0191,
  "setting:venue": 0.1337,
  "setting:water": 0.1043
 },
 "toile": {
  "colour:black": 0.1367,
  "colour:blue": 0.0264,
  "colour:brown": 0.0273,
  "colour:gold": 0.0296,
  "colour:green": 0.0145,
  "colour:grey": 0.008,
  "colour:multicolour": 0.2995,
  "colour:orange": 0.0259,
  "colour:pink": 0.0182,
  "colour:purple": 0.0031,
  "colour:red": 0.0446,
  "colour:white": 0.0108,
  "colour:yellow": 0.0051,
  "season:autumn": 0.0537,
  "season:spring": 0.0531,
  "season:summer": 0.0156,
  "season:winter": 0.0651,
  "style:cartoon": 0.1509,
  "style:flat": 0.3069,
  "style:ink": 0.1262,
  "style:line-art": 0.4342,
  "style:minimal": 0.1171,
  "style:ornamental": 0.1833,
  "style:painted": 0.1398,
  "style:paper": 0.1097,
  "style:pastel": 0.1199,
  "style:poster": 0.11,
  "style:render3d": 0.0386,
  "style:sketch": 0.1765,
  "style:technical": 0.1284,
  "style:vintage": 0.1267,
  "style:watercolor": 0.102,
  "subject:abstract": 0.0503,
  "subject:animals": 0.077,
  "subject:faith": 0.0742,
  "subject:fantasy": 0.0227,
  "subject:food": 0.0438,
  "subject:lettering": 0.1333,
  "subject:nature": 0.0466,
  "subject:objects": 0.1873,
  "subject:people": 0.1074,
  "subject:places": 0.0446,
  "subject:plants": 0.0725,
  "subject:vehicles": 0.0037,
  "use:art-styles": 0.0796,
  "use:beauty": 0.0622,
  "use:body-art": 0.0659,
  "use:business": 0.0156,
  "use:cards": 0.0639,
  "use:classroom": 0.191,
  "use:coloring": 0.0989,
  "use:crafts": 0.0779,
  "use:food": 0.0108,
  "use:games": 0.0242,
  "use:interiors": 0.0139,
  "use:patterns": 0.0668,
  "use:planners": 0.0276,
  "use:references": 0.0293,
  "use:screens": 0.0224,
  "use:social": 0.0145,
  "use:stickers": 0.0321,
  "use:wall-art": 0.1034
 }
}
